// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import moment from "moment";
//请求数据
import VueResource from 'vue-resource';
import store from '@/store';
import './assets/iconfont/iconfont.css'
import './assets/css/global.css'
import './assets/css/icon.css';

Vue.config.productionTip = false

Vue.use(VueResource)
Vue.use(ElementUI)

window.bus = new Vue()

window.IPConfig = { //环境变量发布不同环境需要手动更改 注释日期 2023-04-14
    // 'IP': '/api',
    'IP': '/daily',
};

ElementUI.Dialog.props.closeOnClickModal.default = false;

new Vue({
    el: '#app',
    data() {
        return {
            Time: '',
        }
    },
    created() {
        //    this.nowtime();
        this.getTime();
    },
    watch: {
        Time(newval, oldVal) {
            sessionStorage.removeItem("nowTime");

            // this.time = newval;
            var timeobj = { time: newval }
            sessionStorage.setItem("nowTime", JSON.stringify(timeobj));
            //console.log(newval)
            //console.log(oldVal)
        },
    },
    methods: {
        // nowtime(){
        //    this.Time = moment(new Date()).format("YYYY-MM-DD");
        // },
        getTime() {
            // console.log(IPConfig)
            var riqi = JSON.parse(sessionStorage.getItem("nowTime"));

            if (!riqi && typeof (riqi) != "undefined" && riqi != 0) {
                this.Time = moment(new Date()).format("YYYY-MM-DD");
            } else {
                this.Time = riqi.time;
            }

        }

    },
    router,
    store,
    components: { App },
    template: '<App/>'
})







// WEBPACK FOOTER //
// ./src/main.js